import { Track, } from 'livekit-client';
import { store } from '../../store';
import { updateParticipant } from '../../store/slices/participantSlice';
import { updateScreenSharing } from '../../store/slices/sessionSlice';
import { updateIsMicMuted } from '../../store/slices/bottomIconsActivitySlice';
import { isEmpty } from 'lodash';
export default class HandleMediaTracks {
    constructor(that) {
        this.localTrackPublished = (track, participant) => {
            this.addSubscriber(track, participant);
        };
        this.localTrackUnpublished = (track, participant) => {
            this.removeSubscriber(track, participant);
        };
        this.trackSubscribed = (_, track, participant) => {
            this.addSubscriber(track, participant);
        };
        this.trackUnsubscribed = (track, participant) => {
            this.removeSubscriber(track, participant);
        };
        this.trackMuted = (_, participant) => {
            var _a;
            store.dispatch(updateParticipant({
                id: participant.identity,
                changes: {
                    isMuted: true,
                },
            }));
            if (participant.identity === ((_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.userId)) {
                store.dispatch(updateIsMicMuted(true));
            }
        };
        this.trackUnmuted = (_, participant) => {
            var _a;
            store.dispatch(updateParticipant({
                id: participant.identity,
                changes: {
                    isMuted: false,
                },
            }));
            if (participant.identity === ((_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.userId)) {
                store.dispatch(updateIsMicMuted(false));
            }
        };
        this.trackSubscriptionFailed = (track_sid, participant) => {
            // To do
            console.log('==== trackSubscriptionFailed ====');
            console.log(participant.name, track_sid);
        };
        this.trackStreamStateChanged = (_, streamState, participant) => {
            // to do
            console.log('==== trackStreamStateChanged ====');
            console.log(participant.name, streamState);
        };
        this.that = that;
    }
    addSubscriber(track, participant) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!this.roomMetadata) {
            this.roomMetadata = store.getState().session.currentRoom
                .metadata;
        }
        if (!this.currentUser) {
            this.currentUser = store.getState().session.currentUser;
        }
        if (participant.identity !== ((_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.userId) &&
            track.source === Track.Source.Camera) {
            // if admin_only_webcams or allow_view_other_webcams is enable that time
            // only admin user can see all webcams
            // other user can see only admin users' webcams.
            if ((((_b = this.roomMetadata.room_features) === null || _b === void 0 ? void 0 : _b.admin_only_webcams) ||
                !((_c = this.roomMetadata.room_features) === null || _c === void 0 ? void 0 : _c.allow_view_other_webcams)) &&
                !((_e = (_d = this.currentUser) === null || _d === void 0 ? void 0 : _d.metadata) === null || _e === void 0 ? void 0 : _e.is_admin)) {
                if (participant.metadata && !isEmpty(participant.metadata)) {
                    const metadata = JSON.parse(participant.metadata);
                    // we'll check if user is an admin or not. Otherwise no webcam will show up.
                    if (!metadata.is_admin) {
                        return;
                    }
                }
            }
            if ((_f = this.currentUser) === null || _f === void 0 ? void 0 : _f.isRecorder) {
                // we'll setup logic for webcam recording
                if (participant.metadata && !isEmpty(participant.metadata)) {
                    const metadata = JSON.parse(participant.metadata);
                    if (!metadata.record_webcam) {
                        // if record feature is disable then we won't load webcams
                        return;
                    }
                    else if (!metadata.is_admin &&
                        this.roomMetadata.room_features.recording_features
                            .only_record_admin_webcams) {
                        // if room setting was enable to record webcam only for admin
                        // then we'll simply won't load webcams
                        return;
                    }
                }
            }
        }
        if (track.source === Track.Source.ScreenShare ||
            track.source === Track.Source.ScreenShareAudio) {
            store.dispatch(updateParticipant({
                id: participant.identity,
                changes: {
                    screenShareTrack: 1,
                },
            }));
            store.dispatch(updateScreenSharing({
                isActive: true,
                sharedBy: participant.identity,
            }));
            this.that.setScreenShareTrack(track, participant, true);
        }
        else if (track.source === Track.Source.Microphone) {
            this.that.updateAudioSubscribers(participant);
            const count = participant
                .getTracks()
                .filter((track) => track.source === Track.Source.Microphone).length;
            // now update store
            store.dispatch(updateParticipant({
                id: participant.identity,
                changes: {
                    audioTracks: count === 0 ? 1 : count,
                    isMuted: (_h = (_g = track.audioTrack) === null || _g === void 0 ? void 0 : _g.isMuted) !== null && _h !== void 0 ? _h : false,
                    audioVolume: store.getState().roomSettings.roomAudioVolume,
                },
            }));
        }
        else if (track.source === Track.Source.Camera) {
            this.that.updateVideoSubscribers(participant);
            const count = participant
                .getTracks()
                .filter((track) => track.source === Track.Source.Camera).length;
            // now update store
            store.dispatch(updateParticipant({
                id: participant.identity,
                changes: {
                    videoTracks: count === 0 ? 1 : count,
                },
            }));
        }
    }
    removeSubscriber(track, participant) {
        var _a, _b, _c, _d;
        if (track.source === Track.Source.ScreenShare ||
            track.source === Track.Source.ScreenShareAudio) {
            store.dispatch(updateParticipant({
                id: participant.identity,
                changes: {
                    screenShareTrack: 0,
                },
            }));
            store.dispatch(updateScreenSharing({
                isActive: false,
                sharedBy: '',
            }));
            this.that.setScreenShareTrack(track, participant, false);
        }
        else if (track.source === Track.Source.Microphone) {
            this.that.updateAudioSubscribers(participant, false);
            store.dispatch(updateParticipant({
                id: participant.identity,
                changes: {
                    audioTracks: (_a = participant
                        .getTracks()
                        .filter((track) => track.source === Track.Source.Microphone)
                        .length) !== null && _a !== void 0 ? _a : 0,
                    isMuted: (_c = (_b = track.audioTrack) === null || _b === void 0 ? void 0 : _b.isMuted) !== null && _c !== void 0 ? _c : false,
                },
            }));
        }
        else if (track.source === Track.Source.Camera) {
            this.that.updateVideoSubscribers(participant, false);
            // now update store
            store.dispatch(updateParticipant({
                id: participant.identity,
                changes: {
                    videoTracks: (_d = participant
                        .getTracks()
                        .filter((track) => track.source === Track.Source.Camera)
                        .length) !== null && _d !== void 0 ? _d : 0,
                },
            }));
        }
    }
}
